import { requestRender } from '../state/bus.js';

/* THEME — light/dark for the whole UI chrome. Set from Settings (see
   ui/settings.js) rather than its own topbar toggle now — one row among the
   other workspace prefs there, not a permanent icon button.

   DARK is the default for a session with no saved preference — still set
   explicitly below rather than left as the bare :root, even though :root IS
   the dark palette: an attribute that is always present is one less state to
   reason about, and everything downstream tests for 'light' rather than for
   absence. Once someone actually picks a theme that choice is remembered in
   localStorage and always wins over this default, so anyone who had chosen
   light keeps it — only a browser that never expressed a preference moves. Everything reads off the same
   semantic tokens (--panel, --text, --line, etc.), so flipping the theme
   is one attribute on <html>; nothing here needs to know what any
   individual element looks like — including the viewport's own Orbit
   background and the floating glass palette/view-tabs/hint now, which
   follow the theme the same way everything else does (see app.css's
   --stage and --glass-* tokens). The one thing that doesn't is
   scene/renderer.js's clear colour, which can't read a CSS var — it reads
   the theme attribute directly instead, so a re-render is needed here to
   pick that up immediately rather than waiting for whatever next touches
   the viewport (orbiting, adding an object, ...) to repaint it. */

const KEY = 'illusio3d.theme';

export function currentTheme(){
  return document.documentElement.dataset.theme === 'light' ? 'light' : 'dark';
}

export function setTheme(next){
  document.documentElement.dataset.theme = next;
  localStorage.setItem(KEY, next);
  requestRender();
}

export function initTheme(){
  const saved = localStorage.getItem(KEY);
  document.documentElement.dataset.theme = (saved === 'light' || saved === 'dark') ? saved : 'dark';
}
